import { render, staticRenderFns } from "./UpdateAnnouncement.vue?vue&type=template&id=18fe4044&scoped=true"
import script from "./UpdateAnnouncement.vue?vue&type=script&lang=js"
export * from "./UpdateAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./UpdateAnnouncement.vue?vue&type=style&index=0&id=18fe4044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fe4044",
  null
  
)

export default component.exports